import Axios from 'axios';
import curry from 'lodash/curry';
import flow from 'lodash/flow';
import property from 'lodash/property';
import Papa from 'papaparse';

/* CSV is downloaded as raw data */
const ab2str = (buf) => String.fromCharCode.apply(null, new Uint8Array(buf));

/* Parse the CSV */
const parse_csv = (data) =>
    Papa.parse(data, {
        header: true,
        dynamicTyping: true,
        delimiter: ';',
    });

export const response_to_csv = flow([property('data'), ab2str, parse_csv]);

/* extracts row where Type equals the given type */
export const extract_type = curry((type, csv) =>
    csv.data.filter((row) => row.Type && row.Type === type),
);

export const getRatesFromCSV = async () => {
    const axios = Axios.create({
        timeout: 3000,
        responseType: 'arraybuffer',
        crossdomain: true,
    });
    let rates;
    if (window.location.hostname !== 'localhost') {
        // use of window.location.hostname because URL could be on www.bil.com OR authoring-www.bil.com
        const ratesFile = await axios.get(
            'https://' + window.location.hostname + '/Style%20Library/BIL/data/rates_simu_conso.csv',
        );

        const parsedCSV = await response_to_csv(ratesFile);
        rates = parsedCSV.data;
    } else {
        // LOCAL TESTING
        rates = await import('../resources/rates/rates_simu_conso.csv')
            .then((module) => module.default)
            .then(axios.get)
            .then(response_to_csv)
            .then((csv) => csv.data);
    }

    const standardLoanRate = rates.find(
        (row) => row.Type && row.Type === 'LOAN_RATE',
    );
    const under30LoanRate = rates.find(
        (row) => row.Type && row.Type === 'LOAN_RATE_UNDER_30',
    );
    const greenCarLoanRate = rates.find(
        (row) => row.Type && row.Type === 'LOAN_RATE_GREEN_VEHICLE',
    );

    window.LOAN_RATE =
        typeof standardLoanRate.Taux === 'number' &&
        !Number.isNaN(standardLoanRate.Taux)
            ? standardLoanRate.Taux
            : window.LOAN_RATE;
    window.LOAN_RATE_UNDER_30 =
        typeof under30LoanRate.Taux === 'number' &&
        !Number.isNaN(standardLoanRate.Taux)
            ? under30LoanRate.Taux
            : window.LOAN_RATE_UNDER_30;
    window.LOAN_RATE_GREEN_VEHICLE =
        typeof greenCarLoanRate.Taux === 'number' &&
        !Number.isNaN(standardLoanRate.Taux)
            ? greenCarLoanRate.Taux
            : window.LOAN_RATE_GREEN_VEHICLE;
};
